// eslint-disable-next-line unicorn/prevent-abbreviations
export default class DevInputCardController {
	/* @ngInject */
	constructor() {
		this.data = {
			truc: 'rien',
			card_from: '0',
			card_to: 'N',
		};
		this.jsonEditorOptions = {
			mode:  'code',
			modes: [
				'code',
				'form',
				'text',
				'tree',
				'view',
			],
		};
		this.options = {
			type: 'object',
		};
		this.prefix = 'K_NODE';
		this.readOnly = false;
		this.required = true;
	}
}
